module.exports = __webpack_public_path__ + "img/img_04.ff089497.jpg";